module.exports = __webpack_public_path__ + "img/it_seguromultidispositivo.83d3107d.png";